import React from 'react';
import Input, { type InputProps } from './Input';

export interface PhoneInputProps extends Omit<InputProps, 'type' | 'leftIcon'> {
  // 额外的手机号特定属性可以在这里添加
}

const PhoneInput = React.forwardRef<HTMLInputElement, PhoneInputProps>(
  ({ placeholder = '请输入手机号', maxLength = 20, ...props }, ref) => {
    return (
      <Input
        ref={ref}
        type="tel"
        placeholder={placeholder}
        maxLength={maxLength}
        {...props}
      />
    );
  }
);

PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
